import { Effect, Layer } from "effect";
import { BrowserHttpClient } from "@effect/platform-browser";
import { withWorkerstationBase } from "@workerstation/shared";
import { resourceUnavailable } from "@workerstation/shared/errors/resource";
import { ContainerApi } from "../../api/containers/service.ts";
import { makeContainerApi } from "../../api/containers/live.ts";
import type { ContainerTarget } from "../../api/containers/model.ts";
import { ContainerBrowserIo } from "./service.ts";

export const ContainerBrowserIoLive = Layer.succeed(ContainerBrowserIo, ContainerBrowserIo.of({
  confirmDestroy: Effect.fn("Frontend.Container.confirmDestroy")((target: ContainerTarget) => Effect.try({ try: () => window.confirm(`Destroy Container ${target.bindingName}/${target.instance}?`), catch: () => resourceUnavailable() }))
}));
const ContainerBrowserApiLive = Layer.effect(ContainerApi, Effect.gen(function* () {
  const base = yield* Effect.sync(() => (typeof window === "undefined" ? "https://workerstation.invalid" : window.location.origin) + withWorkerstationBase(""));
  return yield* makeContainerApi(base);
})).pipe(Layer.provide(BrowserHttpClient.layerFetch));
export const ContainerBrowserPortsLive = Layer.merge(ContainerBrowserApiLive, ContainerBrowserIoLive);
